import { Box, ListView } from '@razorpay/blade/components';
import {
  NonPayableBenefitsFilters,
  NonPayableBenefitsListView,
  NonPayableBenefitsDetailView,
} from './index';
import React, { useState } from 'react';
import { StatusFilterKeyType } from 'components/SalaryComponents/components/filters/StatusFilter';

const NonPayableBenefitsView = () => {
  const [counts, setCounts] = useState<Record<StatusFilterKeyType, number>>();
  return (
    <Box paddingX="spacing.8" marginTop="spacing.5">
      <ListView>
        <NonPayableBenefitsFilters counts={counts} />
        <NonPayableBenefitsListView onCountChange={setCounts} />
      </ListView>
      <NonPayableBenefitsDetailView />
    </Box>
  );
};

export default NonPayableBenefitsView;
